// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"3f10b3fb","129":"c7b9a6e5","330":"9cb6d686","588":"c93da178","733":"07db45c2","904":"4dce3b7c"}[chunkId] + ".chunk.js";
};